// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module(__filename, [
    'ui.router',

    require('./list').default,
    require('./supplier').default,

    require('goodeggs-purchase-orders-sdk/catalog/angular_resource'),
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('catalog', {
        url: '/catalog',
        parent: 'foodhub',
        abstract: true,
        data: {pageTitle: 'Catalog'},
        template: '<ui-view></ui-view>',
      }),
    ),
  );

export default __filename;
